import { Button as MuiButton, IconButton as MuiIconButton, DialogContent as MuiDialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(MuiButton)({
  width: "200px",
  textTransform: "none",
  fontSize: "1em",
});

export const IconButton = styled(MuiIconButton)({
  fontSize: "1em",
});

export const DialogContent = styled(MuiDialogContent)({
  overflow: "visible",

  form: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "20px",
  },

  "form .MuiFormControl-root": {
    width: "45%",
  },
});
